<template lang="pug">
  div.w-100(v-if="product")
    .product-list__container(v-if="type === 'vertical'")
      .product-list__discount-tag(v-if="product.sale_price")
        .product-list__discount-tag-value -{{ (((product.price - product.sale_price)/product.price) * 100) | numeral('0') }}%
      .product-list__item
        .product-list__item-tags(v-if="product.badge_new")
          span.product-list__item-tag {{ trans('labels.general.new') }}
        .product-list__item-thumbnail
          router-link(:to='product.permalink', :title="'ดูสินค้า ' + product.name")
            img(:src="'https://www.sparkinter.com/imageproduct/' + product.item_code + '.jpg'" v-if="product.item_code")
        .product-list__item-body
          div
            router-link(:to='product.permalink', :title="'ดูสินค้า ' + product.name")
              h4.product-list__item-title {{ product.name }}
            router-link(:to='product.permalink', :title="'ดูสินค้า ' + product.name")
              .product-list__item-description
                ul
                  li(v-if="product.item_code") Item Code: {{ product.item_code }}
                  li(v-if="product.brand") Brand: {{ product.brand }}
            .product-list__item-footer.row
              .col
                .product-list__item-price(v-bind:class="{'product-list__item-price--discount': product.sale_price}")
                  | {{ trans('labels.frontend.product-list.price') }}
                  span.product-list__item-price-value  {{ product.price | numeral('0,0.00') }} ฿
                  span.product-list__item-price-value.product-list__item-price-value--discount(v-if="product.sale_price") {{ product.sale_price | numeral('0,0.00') }} ฿
                  .d-block.my-1
                    add-to-compare-button(:item="product")
          .product-list__item-overlay.product-list__item-overlay--vertical
            .row.no-gutters.align-items-center
              .col-auto.d-none.d-xl-block
                .product-list__item-overlay-atw
                  add-to-wishlist-button(:item-code="product.item_code" v-if="product.item_code")
              .col-2.d-none.d-xl-block
                input.form-control.product-list__item-overylay-qty(type='number', placeholder='1', value='1', step='1', min='1' v-model="quantity" @focus="onQtyFocus")
              .col
                add-to-cart-button(
                  :product="product"
                  :disabled="!product"
                  button-classes="btn btn-sm btn-primary btn-block btn--add-to-cart"
                  v-if="product"
                  size="sm"
                  hide-label hide-input hide-warning
                )
    .product-list__container(v-if="type === 'horizontal'")
      router-link(:to='product.permalink', :title="'ดูสินค้า ' + product.name")
        .product-list__discount-tag(v-if="product.sale_price")
          .product-list__discount-tag-value -{{ (((product.price - product.sale_price)/product.price) * 100) | numeral('0') }}%
        .product-list__item
          .row
            .col-lg-auto.col-4
              .product-list__item-thumbnail
                router-link(:to='product.permalink', :title="'ดูสินค้า ' + product.name")
                  img(:src="'https://www.sparkinter.com/imageproduct/' + product.item_code + '.jpg'" v-if="product.item_code")
            .col-lg.col-8
              .product-list__item-body
                router-link(:to='product.permalink', :title="'ดูสินค้า ' + product.name")
                  h4.product-list__item-title {{ product.name }}
                .product-list__item-description(v-html="product.short_description")
                img.product-list__item-free-shipping(
                  src="/img/frontend/logo/shipping/free-shipping.png"
                  alt='' width='128px' height='auto'
                  v-if="product.badge_free_shipping"
                )
            .col.text-right
              .product-list__item-price(
                v-bind:class="{'product-list__item-price--discount': product.sale_price}"
              )
                | {{ trans('labels.frontend.product-list.price') }}
                span.product-list__item-price-value  {{ product.price | numeral('0,0.00') }} ฿
                span.product-list__item-price-value.product-list__item-price-value--discount(v-if="product.sale_price") {{ product.sale_price | numeral('0,0.00') }} ฿
              .product-list__item-overlay
                .row.no-gutters.align-items-center
                  .col-auto
                    .product-list__item-overlay-atw
                      add-to-wishlist-button(:item-code="product.item_code")
                  .col-2
                    input.form-control.product-list__item-overylay-qty(type='number', placeholder='1', value='1', step='1', min='1' v-model="quantity")
                  .col
                    router-link.product-list__item-overylay-atc(:to="product.permalink")
                      font-awesome-icon.mr-3(:icon="['far', 'shopping-cart']")
                      | {{ trans('labels.frontend.product-list.more-details') }}
</template>

<script>
import AddToCartButton from "../buttons/shop/AddToCartButton";
import AddToCompareButton from "../buttons/shop/AddToCompareButton";
import AddToWishlistButton from '../buttons/shop/AddToWishlistButton.vue';
import notify from '../notify';
import ConversionManager from '../../mixins/ConversionManager';

export default {
  components: {
    AddToCartButton,
    AddToCompareButton,
    AddToWishlistButton,
  },
  mixins: [ConversionManager],
  props: {
    type: {
      type: String,
      default: 'vertical',
    },
    product: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      quantity: 1,
    };
  },
  methods: {
    async onAddToCart() {
      if (parseInt(this.quantity, 10) <= 0) {
        notify.message(this, { title: Lang.get('alerts.frontend.general.select_at_lease_one'), text: false }, 'danger');
        return;
      }
      try {
        const { data } = await this.$store.dispatch('cart/add', {
          cart_id: this.$store.getters['cart/id'],
          item_code: this.product.item_code,
          quantity: this.quantity,
          redirect: false,
        });
        console.log(data);
        this.trackEvent('Conversion', 'Buttons', 'Buy Now', 'Product List Item (Buy Now)', 1);
        notify.success(this, { title: Lang.get('alerts.frontend.general.added_to_cart'), text: false });
      } catch (e) {
        notify.clean(this).then(() => notify.errors(this, e));
      }
    },
    onQtyFocus() {
      this.quantity = '';
    }
  },
};
</script>
